import { useTranslation } from "react-i18next";
import { formatGermanNumber } from "../../utils/common";

const CandidatesDashboard = ({ data }) => {
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  const { femaleCandidates, totalCandidates, firstTimeCandidates, averageAge } =
    data;
  const isDE = language === "de";
  return (
    <div>
      <div className="bg-wort-background pt-9 pb-2">
        <h3 className="font-bold text-22 leading-[22px] text-center md:text-32 md:leading-38 md:pb-8">
          {t("candidatesOfTheParty")}
        </h3>
        <div className="grid grid-cols-2 wort-small:grid-cols-4 md:grid-cols-4 mt-2">
          <div className="flex justify-center items-center w-108 h-90 flex-col md:border-r-2 md:w-184 md:h-100 ml-10 md:ml-0 mt-8 md:mt-5">
            <span className="text-5xl leading-[45px] font-bold text-secondary md:text-5xl md:leading-10">
              {totalCandidates ? totalCandidates : "-"}
            </span>
            <span className="text-center md:text-base md:leading-5 md:mt-[10px]">
              {t("allCandidates")}¹
            </span>
          </div>
          <div className="flex justify-center items-center w-108 h-90 flex-col mt-5 md:border-r-2 md:w-184 md:h-100">
            <span className="text-5xl leading-[45px] font-bold text-secondary md:text-5xl md:leading-10">
              {femaleCandidates ? femaleCandidates : "-"}
            </span>
            <span className="text-center md:text-base md:leading-5 md:mt-[10px]">
              {t("womenCandidates")}¹
            </span>
          </div>
          <div className="flex justify-center items-center w-108 h-90 flex-col mt-5 md:border-r-2 md:w-184 md:h-100 ml-10 md:ml-0">
            <span className="text-5xl leading-[45px] font-bold text-secondary md:text-5xl md:leading-10">
              {firstTimeCandidates ? firstTimeCandidates : "-"}
            </span>
            <span className="text-center md:text-base md:leading-5 md:mt-[10px]">
              {t("firstElection")}²
            </span>
          </div>
          <div className="flex justify-center items-center w-108 h-90 flex-col mt-5 md:w-184 md:h-100">
            <span className="text-5xl leading-[45px] font-bold text-secondary md:text-5xl md:leading-10">
              {averageAge
                ? isDE
                  ? formatGermanNumber(averageAge)
                  : averageAge
                : "-"}
            </span>
            <span className="text-center md:text-base md:leading-5 md:mt-[10px]">
              {t("averageAge")}¹
            </span>
          </div>
        </div>
        <p className="text-[10px] text-black-rgba mt-6 text-center px-8">
          {t("references[0]")}
          {"     | " + t("references[1]")}
        </p>
      </div>
    </div>
  );
};

export default CandidatesDashboard;
